// googleMapsNavigation.js

const MOBILE_MAPS_FALLBACK_DELAY_MS = 900;

const isFiniteCoordinate = (coordinate) => Number.isFinite(Number(coordinate));

export const getLocationQuery = (location) => {
  if (!location) return '';

  if (isFiniteCoordinate(location.latitude) && isFiniteCoordinate(location.longitude)) {
    return `${Number(location.latitude)},${Number(location.longitude)}`;
  }

  return String(location.titleFull || location.title || '').trim();
};

export const buildGoogleMapsWebUrl = (location) => {
  const query = getLocationQuery(location);
  if (!query) return '';

  const searchParams = new URLSearchParams({
    api: '1',
    query,
  });

  if (location?.placeId) {
    searchParams.set('query_place_id', String(location.placeId));
  }

  return `https://www.google.com/maps/search/?${searchParams.toString()}`;
};

export const buildGoogleMapsAppUrl = (location) => {
  if (typeof navigator === 'undefined') return '';

  const query = getLocationQuery(location);
  if (!query) return '';

  const userAgent = navigator.userAgent || '';
  const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
  const isAndroid = /Android/i.test(userAgent);
  const encodedQuery = encodeURIComponent(query);

  if (isIOS) {
    return `comgooglemaps://?q=${encodedQuery}`;
  }

  if (isAndroid) {
    return `google.navigation:q=${encodedQuery}`;
  }

  return '';
};

export const canOpenLocationInGoogleMaps = (location) => Boolean(getLocationQuery(location));

export const openGoogleMaps = (location) => {
  const webUrl = buildGoogleMapsWebUrl(location);
  if (!webUrl || typeof window === 'undefined') return;

  const appUrl = buildGoogleMapsAppUrl(location);
  if (!appUrl || typeof document === 'undefined') {
    window.open(webUrl, '_blank', 'noopener,noreferrer');
    return;
  }

  let appLaunchDetected = false;

  /**
   * handleVisibilityChange
   *
   * Handles visibility change.
   */
  const handleVisibilityChange = () => {
    if (document.visibilityState === 'hidden') {
      appLaunchDetected = true;
    }
  };

  document.addEventListener('visibilitychange', handleVisibilityChange);

  window.setTimeout(() => {
    document.removeEventListener('visibilitychange', handleVisibilityChange);

    if (!appLaunchDetected) {
      window.location.assign(webUrl);
    }
  }, MOBILE_MAPS_FALLBACK_DELAY_MS);

  window.location.assign(appUrl);
};
